import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const ElevenFtIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-elevenFt"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M20,0 L4,0 C1.79071525,0 0,1.79071525 0,4 L0,30 C0,32.2092847 1.79071525,34 4,34 L20,34 C22.2092847,34 24,32.2092847 24,30 C24,27.7907153 22.2092847,26 20,26 L10,26 C8.89528475,26 8,25.1047153 8,24 L8,10 C8,8.89528475 8.89528475,8 10,8 L20,8 C22.2092847,8 24,6.20928475 24,4 C24,1.79071525 22.2092847,0 20,0 Z M4,2 L20,2 C21.1047153,2 22,2.89528475 22,4 C22,5.10471525 21.1047153,6 20,6 L10,6 C7.79071525,6 6,7.79071525 6,10 L6,24 C6,26.2092847 7.79071525,28 10,28 L20,28 C21.1047153,28 22,28.8952847 22,30 C22,31.1047153 21.1047153,32 20,32 L4,32 C2.89528475,32 2,31.1047153 2,30 L2,4 C2,2.89528475 2.89528475,2 4,2 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <path
          d="M18.5,7 L10.5,7 C8.56685763,7 7,8.56685763 7,10.5 L7,23.5 C7,25.4331424 8.56685763,27 10.5,27 L18.5,27 C20.4331424,27 22,25.4331424 22,23.5 L22,10.5 C22,8.56685763 20.4331424,7 18.5,7 Z M10.5,8 L18.5,8 C19.8808576,8 21,9.11914237 21,10.5 L21,23.5 C21,24.8808576 19.8808576,26 18.5,26 L10.5,26 C9.11914237,26 8,24.8808576 8,23.5 L8,10.5 C8,9.11914237 9.11914237,8 10.5,8 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <polygon
          fill="#00000"
          className={styles.defaultColor}
          points="7.5 17 21.5 17 21.5 16 7.5 16"
        />
        <path
          d="M25.4623 16.1565C24.8463 16.5315 24.8463 17.4685 25.4623 17.8435L27.5373 19.1055 29.6133 20.3685C30.2293 20.7425 31.0003 20.2745 31.0003 19.5245L31.0003 17.0005 31.0003 14.4755C31.0003 13.7255 30.2293 13.2575 29.6133 13.6315L27.5373 14.8945 25.4623 16.1565ZM56.5377 16.1565C57.1537 16.5315 57.1537 17.4685 56.5377 17.8435L54.4627 19.1055 52.3867 20.3685C51.7707 20.7425 50.9997 20.2745 50.9997 19.5245L50.9997 17.0005 50.9997 14.4755C50.9997 13.7255 51.7707 13.2575 52.3867 13.6315L54.4627 14.8945 56.5377 16.1565Z"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
        <polygon
          fill="#0050B3"
          className={styles.interactiveColor}
          points="30 18 52 18 52 16 30 16"
        />
        <path
          d="M64,4 L62,4 C60.8957153,4 60,4.89571525 60,6 L60,28 C60,29.1042847 60.8957153,30 62,30 L64,30 C65.1042847,30 66,29.1042847 66,28 L66,6 C66,4.89571525 65.1042847,4 64,4 Z M62,6 L64,6 L64,28 L62,28 L62,6 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <path
          d="M66.5,11.5 L65.5,11.5 C64.6718576,11.5 64,12.1718576 64,13 L64,21 C64,21.8281424 64.6718576,22.5 65.5,22.5 L66.5,22.5 C67.3281424,22.5 68,21.8281424 68,21 L68,13 C68,12.1718576 67.3281424,11.5 66.5,11.5 Z M65.5,12.5 L66.5,12.5 C66.7758576,12.5 67,12.7241424 67,13 L67,21 C67,21.2758576 66.7758576,21.5 66.5,21.5 L65.5,21.5 C65.2241424,21.5 65,21.2758576 65,21 L65,13 C65,12.7241424 65.2241424,12.5 65.5,12.5 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
      </g>
    </Icon>
  )
}
